import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=4caf1e59&"
import script from "./documents.vue?vue&type=script&lang=ts&"
export * from "./documents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports